export const projects = [
    {
        "id": 1,
        "name": "AniUI",
        "src": "aniui.webp",
        "href": "https://aniui.dev",
        "description": "Open-source React Native design system — 149 copy-paste components, screen blocks, charts, and a shadcn-compatible registry. Built for Expo, NativeWind, and Uniwind.",
        "category": "Open Source · React Native",
        "tech": ["React Native", "Expo", "TypeScript", "NativeWind", "CLI"]
    },
    {
        "id": 2,
        "name": "AniUI Pro",
        "src": "aniuipro.png",
        "href": "https://pro.aniui.dev",
        "description": "Premium React Native screen templates, blocks, and boilerplates — ship production apps in days instead of rebuilding the same UI from scratch.",
        "category": "Product · React Native",
        "tech": ["React Native", "Next.js", "TypeScript", "Tailwind CSS"]
    },
    {
        "id": 3,
        "name": "AniUI Academy",
        "src": "aniuiacademy.png",
        "href": "https://academy.aniui.dev",
        "description": "Learn frontend and mobile by writing code — interactive lessons with live playgrounds, XP, and progress tracking across JavaScript, React, and React Native.",
        "category": "EdTech · Web",
        "tech": ["Next.js", "TypeScript", "MDX", "Tailwind CSS"]
    },
    {
        "id": 4,
        "name": "anishl.dev",
        "src": "anishl.webp",
        "href": "https://anishl.dev",
        "description": "Personal brand site showcasing the AniUI ecosystem, mobile apps, and open-source work — Next.js 14, Tailwind CSS, and Framer Motion. Fully open source.",
        "category": "Web Development",
        "tech": ["Next.js", "TypeScript", "Tailwind CSS", "Framer Motion"]
    },
    {
        "id": 5,
        "name": "Portfolio V3",
        "src": "portolio-v3.png",
        "href": "/",
        "description": "Interactive portfolio with GSAP animations, printable ATS-friendly resume, and a full career timeline.",
        "category": "Web Development",
        "tech": ["React", "GSAP", "SCSS"]
    },
    {
        "id": 6,
        "name": "Portfolio V2",
        "src": "portfolion.webp",
        "href": null,
        "description": "Previous portfolio version featuring advanced animations and 3D elements.",
        "category": "Web Development",
        "tech": ["React", "GSAP", "SCSS"],
        "archived": true,
        "archivedMessage": "Evolved into V3 & anishl.dev"
    }
]
